export default __webpack_public_path__ + "static/media/6.7cbf27b2.JPG";